// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// 生产环境中注释掉以下语句
import 'sysStatic/css/theme-default.scss'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './components/install'
import domain from './service/getData'
import ajax from './service/ajax'
import common from './service/common'
import VueClipboard from 'vue-clipboard2'


Vue.prototype.$domain=domain  //全局引入接口路径
Vue.prototype.$ajax=ajax  //全局引入接口路径
Vue.prototype.$common=common  //全局引入接口路径
Vue.use(ElementUI);
Vue.use(VueClipboard)//复制
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js